/***
*
*   APP LAYOUT
*   Main application layout containing the navigation
*   and header (title, secondary nav and signed in user)
*
*   PROPS
*   title: title of the view
*
**********/

import { Fragment, useContext } from 'react';
import { Box } from '@mui/material';
import { AuthContext, AppNav, Header, User } from 'components/lib';
import Style from './app.module.scss';
import '@farcaster/auth-kit/styles.css';
import { ConsoleUser } from 'mbd-components/console-user';
export function AppLayout(props){

  // context & style
  const context = useContext(AuthContext);

  return (
    <Fragment>
      <AppNav
        items={[
          { label: 'Start', icon: 'terminal', link: '/getting-started' },
          { label: 'Dashboard', icon: 'activity', link: '/dashboard' },
          // {label: 'Playground', icon: 'code', link: '/playground'},
          { label: 'Feed Builder', icon: 'settings', link: '/feed-builder' },
          // { label: 'Data Sources', icon: 'database', link: '/data-sources' },
          { label: 'Moderation', icon: 'shield', link: '/moderation' },
          { label: 'Usage', icon: 'bar-chart-2', link: '/usage' },
          { label: 'Account', icon: 'user', link: '/account', },
          { label: 'Documentation', icon: 'book', link: 'https://docs.mbd.xyz/reference', },
          { label: 'Help', icon: 'help-circle', link: '/help' },
          { label: 'Sign Out', icon: 'log-out', action: context.signout }
        ]}
      />

      <main className={ Style.app }>

        <Header title={ props.title }>
          {/* <User/> */}
          <Box sx={{position: 'absolute', right: 25, top: 16, display: 'flex', justifyContent: 'flex-end'}}>
            <ConsoleUser />
          </Box>
        </Header>

        { <props.children {...props.data }/> }

      </main>
    </Fragment>
  );
}